import { FastField } from 'formik';

import { TextField } from 'components/formik/text-field';

const ReferralCodeField = (): JSX.Element => (
    <FastField
        fullWidth
        name="refered"
        label="کد معرف را وارد نمایید (اختیاری)"
        icon={<i className="fa-light fa-users-medical" />}
        component={TextField}
        disableAutoFill
        liveValidation={false}
        clearErrorOnChange
        ltr="true"
        maxLength={6}
    />
);

export default ReferralCodeField;
